module.exports = __webpack_public_path__ + "img/right.0bc2eb24.png";